var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 5.333H3.333c-1.106 0-2 .894-2 2v4H4V14h8v-2.667h2.667v-4c0-1.106-.894-2-2-2zm-2 7.334H5.334V9.333h5.333v3.334zm2-4.667A.669.669 0 0112 7.333c0-.366.3-.666.667-.666.367 0 .667.3.667.666 0 .367-.3.667-.667.667zM12 2H4v2.667h8V2z",
    fill: "currentColor"
  })));
}

export default SvgPrint;